<template>
  <div>
    <!-- 自定义导航 -->
    <Nav></Nav>
    <!-- 自定义导航-->
    <!-- 首页内容-->
    <div class="content-wrap">
      <!-- 联系方式-->
      <div class="top-wrap">
        <div class="title">连接电影票务交易各方</div>
        <div class="sub-title">
          为开发者、渠道方、推广者与服务提供方提供接入、推广、订<br />
          单流转、履约协同与结算支持
        </div>
        <div class="contact">
          <div>
            <div class="img-box"><img src="../../../assets/img/h5/applet.jpg" alt=""></div>
            <div class="img-tip">购票体验小程序</div>
          </div>
          <div>
            <div class="img-box"><img class="qrcode" src="../../../assets/img/h5/qrcode.jpg" alt=""></div>
            <div class="img-tip">联系商务微信</div>
          </div>
        </div>
      </div>
      <!-- 联系方式-->
      <!-- 为什么选择守兔开放平台-->
      <div class="advantage-wrap padding-15">
        <div class="advantage-title">为什么选择守兔开放平台</div>
        <div class="poster-div">
          <img src="../../../assets/img/h5/home_banner.png" alt="">
        </div>
        <div>
          <div class="adv-box">
            <div>
              <img class="adv-img" src="../../../assets/img/h5/home_icon_discounts_1.png" alt="">
            </div>
            <div class="adv-text">
              <div class="adv-title">特惠购票与快速出票，灵活匹配购票需求</div>
              <div class="adv-content"><span>特惠购票：</span>由合作服务方提供优惠购票能力，适合对价格敏感的购票场景</div>
              <div class="adv-content"><span>快速出票：</span>由合作服务方提供快速出票能力，适合对出票时效要求较高的购票场景</div>
            </div>
          </div>
          <div class="adv-box">
            <div>
              <img class="adv-img" src="../../../assets/img/h5/home_icon_cinema_2.png" alt="">
            </div>
            <div class="adv-text">
              <div class="adv-title">覆盖全国主流影院资源</div>
              <div class="adv-content">支持对接全国多地影院服务资源，优先覆盖主流连锁影院及热门影城</div>
            </div>
          </div>
          <div class="adv-box">
            <div>
              <img class="adv-img" src="../../../assets/img/h5/home_icon_demand_3.png" alt="">
            </div>
            <div class="adv-text">
              <div class="adv-title">多类合作接入方案，匹配不同业务场景</div>
              <div class="adv-content">支持 H5 接入与推广转化</div>
              <div class="adv-content">支持公众号接入、消息推送与订单转化</div>
              <div class="adv-content">支持小程序接入与渠道推广协同</div>
              <div class="adv-content">支持推广分销配置、订单管理与结算协同</div>
              <div class="adv-content">支持企业合作，可按业务场景接入开放平台能力</div>
              <div class="adv-content">申请开放平台开发者，可接入影院、影片、排期、选座、订单流转等接口能力</div>
            </div>
          </div>
          <div class="adv-box">
            <div>
              <img class="adv-img" src="../../../assets/img/h5/home_icon_service_4.png" alt="">
            </div>
            <div class="adv-text">
              <div class="adv-title">售后协助与履约支持</div>
              <div class="adv-content">提供订单流转、履约协同与售后协助支持，具体服务范围以合作协议为准</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 为什么选择守兔开放平台-->
      <!-- 合作接入方案-->
      <div class="promotion-wrap padding-15">
        <div class="promotion-title">多类合作接入方案，匹配不同业务场景</div>
        <div>
          <div class="pro-div">
            <div class="pro-title-box">
              <div class="pro-title">H5 / 公众号接入</div>
              <div class="pro-btn-box">
                <span class="pro-btn" @click="contact()">申请接入</span>
              </div>
            </div>
            <div class="league-box">
              <span>服务接入费：99元/年 - 499元/年</span>
            </div>
            <div class="pro-des-box">
              <div class="pro-des-div">订单收益按合作规则结算</div>
              <div class="pro-des-div">支持微信服务号模板推送</div>
              <div class="pro-des-div">完成接入后即可开展推广，适合公众号、社群等私域渠道转化</div>
              <div class="pro-des-div">结算周期以平台配置和合作协议为准</div>
            </div>
          </div>
          <div class="pro-div">
            <div class="pro-title-box">
              <div class="pro-title">小程序接入</div>
              <div class="pro-btn-box">
                <span class="pro-btn" @click="contact()">申请接入</span>
              </div>
            </div>
            <div class="league-box">
              <span>服务接入费：99元/年 - 499元/年</span>
            </div>
            <div class="pro-des-box">
              <div class="pro-des-div">订单收益按合作规则结算</div>
              <div class="pro-des-div">适合具备企业主体和独立小程序的合作方接入使用</div>
              <div class="pro-des-div">支持渠道推广、用户增长与订单转化</div>
              <div class="pro-des-div">结算周期以平台配置和合作协议为准</div>
            </div>
          </div>
          <div class="pro-div">
            <div class="pro-title-box">
              <div class="pro-title">API 接入</div>
              <div class="pro-btn-box">
                <span class="pro-btn" @click="contact()">申请接入</span>
              </div>
            </div>
            <div class="league-box">
              <span>API 服务接入费：3000元/年</span>
            </div>
            <div class="pro-des-box">
              <div class="pro-des-div">提供接口接入、订单流转、履约协同及技术服务支持</div>
              <div class="pro-des-div">服务费及返还规则以具体合作协议为准</div>
              <div class="pro-des-div">适合 APP、小程序、H5 等业务形态接入开放平台能力</div>
            </div>
          </div>
          <div class="pro-div">
            <div class="pro-title-box">
              <div class="pro-title">独立版H5系统</div>
              <div class="pro-btn-box">
                <span class="pro-btn" @click="contact()">咨询顾问</span>
              </div>
            </div>
            <div class="league-box">
              <span>加盟费：5999元/年</span>
            </div>
            <div class="pro-des-box">
              <div class="pro-des-div">部署整套购票系统，支持任意公众号生成唯一购票链接</div>
              <div class="pro-des-div">可自主招收H5分销代理，自定义分佣比例</div>
              <div class="pro-des-div">自有域名，自主品牌，收款到自有商户号，仅支付出票成本</div>
              <div class="pro-des-div">灵活定义票价折扣，自主掌握利润比例</div>
            </div>
          </div>
          <div class="pro-div">
            <div class="pro-title-box">
              <div class="pro-title">影票小程序</div>
              <div class="pro-btn-box">
                <span class="pro-btn" @click="contact()">咨询顾问</span>
              </div>
            </div>
            <div class="league-box">
              <span>加盟费：99元/年</span>
            </div>
            <div class="pro-des-box">
              <div class="pro-des-div">收费最高99元/年<span>分润70%-90%</span></div>
              <div class="pro-des-div">支持服务号、订阅号呼起小程序</div>
              <div class="pro-des-div">新关注小程序的粉丝都归于你名下</div>
              <div class="pro-des-div">享受二级分佣收益，升级总监再享受团队收益</div>
              <div class="pro-des-div">放映两小时后结算，秒提现</div>
            </div>
          </div>
          <div class="pro-div">
            <div class="pro-title-box">
              <div class="pro-title">独立版小程序系统</div>
              <div class="pro-btn-box">
                <span class="pro-btn" @click="contact()">咨询顾问</span>
              </div>
            </div>
            <div class="league-box">
              <span>加盟费：5999元/年</span>
            </div>
            <div class="pro-des-box">
              <div class="pro-des-div">部署整套属于自己的小程序品牌，解析到自己的域名</div>
              <div class="pro-des-div">预存款的合作方式，利润空间100%归你</div>
              <div class="pro-des-div">支持对接n个公众号，订阅号、小程序</div>
              <div class="pro-des-div">灵活定义票价折扣，自主掌握利润空间</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 合作接入方案-->
      <!-- 加入守兔开放平台-->
      <div class="joinus-wrap padding-15">
        <div class="joinus-title">加入守兔开放平台，完成合作接入</div>
        <div class="step-title">简单3步，完成合作接入</div>
        <div class="step-img">
          <!-- <img src="../../../assets/img/h5/home_icon_buzhou.png" alt=""> -->
          <div class="step-img-box">
            <div>
              <img src="../../../assets/img/h5/home_icon_register_1.png" alt="">
            </div>
            <div>
              <img src="../../../assets/img/h5/home_icon_arrow.png" alt="">
            </div>
            <div>
              <img src="../../../assets/img/h5/home_icon_getcode_2.png" alt="">
            </div>
            <div>
              <img src="../../../assets/img/h5/home_icon_arrow.png" alt="">
            </div>
            <div>
              <img src="../../../assets/img/h5/home_icon_earn_3.png" alt="">
            </div>
          </div>
          <div class="step-text">
            <div>注册账号</div>
            <div>申请接入并获取推广物料</div>
            <div>按合作规则结算收益</div>
          </div>
        </div>
      </div>
      <!-- 加入守兔开放平台-->
      <!-- 底部-->
      <div class="footer-wrap padding-15">
        <div class="footer-box">
          <div class="footer-tag">
            <span>关于我们</span>
            <span>法律声明</span>
            <span>廉政举报</span>
            <span>友情链接</span>
          </div>
          <div class="copyright">© 2020-2030 shoutu.com 版权所有 ICP：闽DSS2-487545</div>
        </div>
      </div>
      <!-- 底部 -->
    </div>
    <!-- 首页内容-->
    <Contact ref="Contact" />
    </Contact>
  </div>
</template>

<script>
import Nav from '@/components/h5/Nav.vue'
import Contact from '@/views/h5/home/modal/Contact'
export default {
  name: 'Home',
  components: {
    Nav,
    Contact
  },
  data() {
    return {}
  },
  created() {
    if (this.$route.query.invite_code) {
      let inviteCode = this.$route.query.invite_code
      localStorage.setItem('inviteCode', inviteCode)
    }
  },
  methods: {
    // 联系我们
    contact: function () {
      this.$refs.Contact.init(true)
    },
  }
}
</script>

<style lang="less" scoped>
.content-wrap {
  position: absolute;
  width: 100%;

  .top-wrap {
    min-height: 400px;
    background-image: url(../../../assets/img/h5/home_bg.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;
    width: 100%;
    color: #FFFFFF;
    text-align: center;
    padding: 60px 0;

    .title {
      font-size: 48px;
      line-height: 64px;
      padding: 10px 0;
      font-family: Alibaba-PuHuiTi-M;
    }

    .sub-title {
      font-size: 22px;
      line-height: 32px;
      padding-left: 20px;
      padding-right: 20px;
      padding-bottom: 40px;
      font-family: Alibaba-PuHuiTi-R;
    }

    .contact {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-around;
      padding: 0 20px;

      .img-box {
        width: 110px;
        height: 110px;
        background: #FFFFFF;

        img {
          width: 98px;
          height: 98px;
          margin-top: 6px;
        }

        .qrcode {
          width: 110px;
          height: 110px;
          margin-top: 0px;
        }
      }

      .img-tip {
        padding-top: 10px;
        font-family: Alibaba-PuHuiTi-R;
      }
    }
  }

  .advantage-wrap {
    background: #FFFFFF;

    .advantage-title {
      font-size: 24px;
      color: #222222;
      letter-spacing: 0;
      padding-top: 10px;
      font-family: Alibaba-PuHuiTi-M;
    }

    .poster-div {
      padding: 25px 0;

      img {
        width: 100%;
      }
    }

    .adv-box {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding-bottom: 25px;

      .adv-img {
        width: 40px;
      }

      .adv-text {
        padding-left: 10px;

        .adv-title {
          color: #222222;
          font-size: 16px;
          padding: 2px 0;
          font-family: Alibaba-PuHuiTi-M;
        }

        .adv-content {
          color: #999999;
          font-size: 13px;
          line-height: 23px;
          font-family: Alibaba-PuHuiTi-R;

          span {
            color: #666666;
          }
        }
      }
    }
  }

  .promotion-wrap {
    background: #F3F3F3;
    font-family: Alibaba-PuHuiTi-R;

    .promotion-title {
      font-size: 24px;
      color: #222222;
      letter-spacing: 0;
      padding: 20px 0;
      font-family: Alibaba-PuHuiTi-M;
    }

    .pro-div {
      background: #FFFFFF;
      padding: 15px;
      margin-bottom: 15px;

      .pro-title-box {
        min-height: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        .pro-title {
          font-size: 16px;
          color: #222222;
          line-height: 22px;
          font-family: Alibaba-PuHuiTi-M;
        }

        .pro-btn-box {
          font-size: 14px;
          color: #FFFFFF;

          .pro-btn {
            background: #FF8622;
            padding: 5px 10px;
          }
        }
      }

      .league-box {
        font-size: 12px;
        color: #FF8622;
        letter-spacing: 0;
        text-align: justify;
        margin: 2px 0 5px 0;

        span {
          background: #FFF8F2;
          padding: 2px 6px;
        }
      }

      .pro-des-box {
        color: #999999;
        font-size: 13px;
        line-height: 20px;

        .pro-des-div span {
          color: #FF4F76;
        }
      }
    }
  }

  .joinus-wrap {
    background: #FFFFFF;
    font-family: Alibaba-PuHuiTi-R;

    .joinus-title {
      font-size: 24px;
      color: #222222;
      letter-spacing: 0;
      padding: 20px 0 10px 0;
      font-family: Alibaba-PuHuiTi-M;
    }

    .step-title {
      color: #666666;
      font-size: 14px;
      padding-bottom: 20px;
    }

    .step-img {
      padding: 20px 8px;

      .step-img-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        img {
          width: 100%;
        }
      }

      .step-text {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-around;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0;
        padding-top: 10px;
        color: #666666;

        div {
          width: 33%;
          text-align: center;
          padding: 0 4px;
        }
      }
    }
  }

  .footer-wrap {
    background: #333333;
    font-family: "microsoft yahei";

    .footer-box {
      padding: 30px 8px;

      .footer-tag {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        color: #ffffff;
      }

      .copyright {
        padding-top: 20px;
        font-size: 12px;
        color: #999999;
        text-align: center;
      }
    }
  }
}

.padding-15 {
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/h5/home/Index.vue